// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles-module--checkbox--21lp_","checked":"styles-module--checked--3uH_h"};